import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { SilometrixThresholdDefaultResponse } from './silometrix-threshold-default.types';

export async function SilometrixThresholdDefaultService() {
  const { response, data } = await BACKEND.get<SilometrixThresholdDefaultResponse>(
    ENDPOINT.METRICS_ALERTS_CONFIG_DEFAULTS
  );

  return {
    response,
    summary: data,
  };
}
